import { KMF_COVER_CATEGORIES, KMF_POPUP_MODAL, PAGE_INDICES } from '../../../actions/kaMetlhaFuneralCover/types';
import {
    navigateToReplacementPolicy,
    navigateToPersonalDetails,
    navigateToLivesCovered,
    navigateToBeneficiaries,
    navigateToPaymentDetails,
    navigateToConfirmation,
    navigateToThankYou,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToUploadDocuments,
    navigateToBeneficiaryDetails,
    transitionScrolling,
} from '../../../actions/kaMetlhaFuneralCover/routing';

import { getActivePageIndex } from '../../../selectors/kaMetlhaFuneralCover/routing';
import { FIELD_STATUS } from '../../../reducers/status';
import { getBankingDetailsForm } from '../../../selectors/kaMetlhaFuneralCover/bankingDetails';
import { setKmfBankingDetailsValue } from '../../../actions/kaMetlhaFuneralCover/bankingDetails';
import { getPurchasePersonalDetailsForm } from '../../../selectors/kaMetlhaFuneralCover/personalDetails';
import { setPurchasePersonalDetailsFieldValue } from '../../../actions/kaMetlhaFuneralCover/personalDetails';
import { setKmfDocumentValue } from '../../../actions/kaMetlhaFuneralCover/uploadDocuments';
import { getUploadDocumentForm } from '../../../selectors/kaMetlhaFuneralCover/uploadDocuments';
import { getLivesCovered, getLivesCoveredFormStatus } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { setPopupModalValue } from '../../../actions/kaMetlhaFuneralCover/quote';
import { submitPolicy, uploadDocumentsRequest } from '../../../actions/kaMetlhaFuneralCover/policyRequest';
import { getTermsAndConditions } from '../../../selectors/kaMetlhaFuneralCover/referenceData';


const bankingDetailsKeys = ['accountHolder','bankName','branchCode','accountNumber','accountType','debitOrderDay','paymentAuthorization'];
// const uploadDocumentsKeys=['incomeProof','bankStatement','addressProof','certifiedCopyOfId']

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) {
        return next(action);
    }

    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }

    onNavigatePrevious(store, state, activePageIndex);

    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    const bankingFormFields = getBankingDetailsForm(state);
    const uploadDocumentsFormFields = getUploadDocumentForm(state);
    const uploadDocumentsKeys=Object.keys(uploadDocumentsFormFields).filter((docKey)=>uploadDocumentsFormFields[docKey].status===FIELD_STATUS.ERROR)
    const personalDetailFormFields=getPurchasePersonalDetailsForm(state)
    const termsAndCondition=getTermsAndConditions(state)
    const personalDetailsKeys=Object.keys(personalDetailFormFields)
    const replacementPolicyKeys=['employementType']
    const livesCovered=getLivesCovered(state)
    const formStatusResult=getLivesCoveredFormStatus(state)
    const isBeneficiaryAdded=Object.keys(livesCovered[KMF_COVER_CATEGORIES.BENEFECIARY]).length
    switch (activePageIndex) {
        case PAGE_INDICES.REPLACEMENT_POLICY:
            validateFormDetails(store, personalDetailFormFields, replacementPolicyKeys, setPurchasePersonalDetailsFieldValue) &&
            performPersonalDetailNavigation(store, state);
            break;

        case PAGE_INDICES.PERSONAL_DETAILS:
             validateFormDetails(store, personalDetailFormFields, personalDetailsKeys, setPurchasePersonalDetailsFieldValue) &&
             performLivesCoveredNavigation(store, state);
            break;

        case PAGE_INDICES.LIVES_COVERED:
            !formStatusResult ? store.dispatch(setPopupModalValue(KMF_POPUP_MODAL.INCOMPLETE_MODAL)):
            store.dispatch(navigateToBeneficiaryDetails()) 
            break;

        case PAGE_INDICES.BENEFICIARIES:
            !isBeneficiaryAdded ? store.dispatch(setPopupModalValue(KMF_POPUP_MODAL.ADD_BENEFICIARY_MODAL)):
            store.dispatch(navigateToPaymentDetails());
            break;

        case PAGE_INDICES.PAYMENT_DETAILS:
            validateFormDetails(store, bankingFormFields, bankingDetailsKeys, setKmfBankingDetailsValue) &&
                store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            // getUploadDocumentsValid(state) ?
            validateFormDetails(store, uploadDocumentsFormFields, uploadDocumentsKeys, setKmfDocumentValue) &&
            performUploadDocumentsNavigation(store, state);
            // : performUploadDocumentsValidation(store)
            break;

        case PAGE_INDICES.CONFIRMATION:
            // termsAndCondition &&
            store.dispatch(uploadDocumentsRequest()) 
            //  performThankYouNavigation(store);
            break;

        case PAGE_INDICES.THANK_YOU:
            break;
    }
};


const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.REPLACEMENT_POLICY:
            break;

        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToReplacementPolicy());
            break;

        case PAGE_INDICES.LIVES_COVERED:
            store.dispatch(navigateToPersonalDetails());
            break;

        case PAGE_INDICES.BENEFICIARIES:
            store.dispatch(navigateToLivesCovered());
            break;

        case PAGE_INDICES.PAYMENT_DETAILS:
            store.dispatch(navigateToBeneficiaryDetails());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToPaymentDetails());
            break;
        case PAGE_INDICES.CONFIRMATION:
            store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.THANK_YOU:
            store.dispatch(navigateToConfirmation());
            break;
    }
};

const performPersonalDetailNavigation = (store, state) => {
    // const { employementType } = getPersonalDetailsForm(state);
    // if(!employementType.value){
    //     store.dispatch(setEmployementTypeValue(employementType.value))
    //     return false
    // }
    store.dispatch(navigateToPersonalDetails());
};
const performLivesCoveredNavigation = (store, state) => {
    // const livesCoveredForm = getCoverMembersForms(state);
    // if ('myself' in livesCoveredForm) {
    //     livesCoveredUpdatePersonalValueRules(store);
    // }

    store.dispatch(navigateToLivesCovered());
};

// const performPaymentDetailsNavigation = (store, state) => {
//     const skipConfirmationPage = getSkipConfirmationPage(state);

//     if(skipConfirmationPage){
//         const paymentDetailsValid = getPaymentDetailsValid(state);
//         const confirmDetailsValid = getConfirmDetailsValid(state);

//         // Handle payment details valid
//         if(!paymentDetailsValid)
//             performPaymentDetailsValidation(store);

//         // Handle confirm details valid
//         if(!confirmDetailsValid)
//             performConfirmDetailsValidation(store);

//         // Handle success
//         if(paymentDetailsValid && confirmDetailsValid)
//             performThankYouNavigation(store);

//     } else {
//         !getPaymentDetailsValid(state) ? performPaymentDetailsValidation(store) : store.dispatch(navigateToUploadDocuments())
//     }
// }
const performUploadDocumentsNavigation = (store, state) => {
    //Dispatch Action For Api Call
    // store.dispatch(sendUploadDocuments())
    store.dispatch(navigateToConfirmation());
};
const performThankYouNavigation = (store) => {
    // store.dispatch(sendConfirmDetailsSubmitApplication());
    store.dispatch(navigateToThankYou());
};

 const validateFormDetails = (store, formFields, validationFieldKeys, validatorAction) => {
    const validate = (fieldValue, fieldType) => {
        const { status, value=null, displayValue=null ,fileName=null,fileContaint=null,file=null} = fieldValue[fieldType];
        return status !== FIELD_STATUS.VALID
            ? store.dispatch(
                 validatorAction({ fileName, fileContaint, file, inputType:fieldType, fieldType,
                    value,
                    displayValue, })
              )
            : [];
    };
    const inValidFields = validationFieldKeys?.flatMap((field) => {
        const dependentField = formFields[formFields[field]?.dependentField];
        const dependentValue = formFields[field]?.dependentValue;
        const defaultValidationCondition=(dependentValue,actualValue)=> dependentValue === actualValue.value
        const validationCondition=formFields[field].validationCondition ?? defaultValidationCondition
        if (dependentField) {
            return validationCondition(dependentValue,dependentField) ? validate(formFields, field) : [];
        } else {
            return validate(formFields, field);
        }
    });
    store.dispatch(transitionScrolling.scrollToId(inValidFields[0]?.value?.fieldType))
    return !inValidFields.length;
};
